import React from 'react'
import { connect } from 'react-redux'
import {Field, reduxForm, formValueSelector} from 'redux-form'
import asyncValidate from './validations/asyncValidate'
import validate from './validations/validate'
import renderField from './components/fields/renderField';
import renderSelect from './components/fields/renderSelect';
import individual from './images/individual.svg'
import company from './images/company.svg'
import { CSSTransitionGroup } from 'react-transition-group'
import i18n from './translations/i18n';

const selector = formValueSelector('davron')

const UserType = props => {
	let { lng, individualChange, companyChange } = props;
	return (
		<div className="row">
			<div className="col-6">
				<div className="radio-button">
					<Field
						name="userType"
						id="individual"
						type="radio"
						component="input"
						value="individual"
						normalize={individualChange}
					/>
					<label htmlFor="individual" className="davron-label">
					<img src={individual} alt="individual-logo" />
					{i18n.t('basic_info.individual', {lng})}
					</label>
					</div>
				</div>
				<div className="col-6">
				<div className="radio-button">
					<Field
						name="userType"
						id="company"
						type="radio"
						component="input"
						value="company"
						normalize={companyChange}
					/>
					<label htmlFor="company" className="davron-label">
					<img src={company} alt="company-logo" />
					{i18n.t('basic_info.company', {lng})}
					</label>
				</div>
			</div>
		</div>
	)
}

const CompanyField = props => {
	let lng = props.lng;
	return (
		<div className="row">
			<div className="col-12 form-input">
				<Field
					name="company"
					type="text"
					component={renderField}
					label={i18n.t('basic_info.company_name', {lng})}
					placeholder={i18n.t('basic_info.company_name_placeholder', {lng})}
				/>
			</div>
		</div>
	)
}

const BasicData = props => {
	let lng = props.lng;
	let currencies = ["EUR", "GBP", "USD"]
	return (
		<div>
		<div className="row">
			<div className="col-12 col-sm-6 form-input">
				<Field
					name="firstName"
					type="text"
					component={renderField}
					label={i18n.t('basic_info.first_name', {lng})}
					placeholder={i18n.t('basic_info.first_name_placeholder', {lng})}
				/>
			</div>
			<div className="col-12 col-sm-6 form-input">
				<Field
					name="lastName"
					type="text"
					component={renderField}
					label={i18n.t('basic_info.last_name', {lng})}
					placeholder={i18n.t('basic_info.last_name_placeholder', {lng})}
				/>
			</div>
			<div className="col-12 col-sm-6 form-input">
				<Field
					name="email"
					type="email"
					component={renderField}
					label={i18n.t('basic_info.email', {lng})}
					placeholder={i18n.t('basic_info.email_placeholder', {lng})}
				/>
			</div>
			<div className="col-12 col-sm-6 form-input">
				<Field
					name="phone"
					type="phone"
					component={renderField}
					label={i18n.t('basic_info.phone', {lng})}
					placeholder={i18n.t('basic_info.phone_placeholder', {lng})}
				/>
			</div>
		</div>
		<div className="row mt-5">
			<div className="col-6 form-input currency-div">
				<p>{i18n.t('basic_info.currency_info', {lng})}</p>
			</div>
			<div className="col-6 form-input">
				<Field
					name="currency"
					type="currency"
					component={renderSelect}
					options={currencies}
					label={i18n.t('basic_info.currency', {lng})}
					onChange={props.deliveryChange}
					placeholder={i18n.t('app.please_select', {lng})}
				/>
			</div>
		</div>
		</div>
	)
}

const DavronFormBasicData = props => {
	let isCompany = props.isCompany;
	let lng = props.lng;
	return (
		<div className="form-section">
			<div className="subtitle title title-border title-border text-left">
				<h6>{i18n.t('basic_info.title', {lng})}</h6>
			</div>
			<p className="small tooltip-text">{i18n.t('basic_info.subtitle', {lng})}</p>
			{isCompany&&<CompanyField 
				lng={props.lng}
			/>}
			<BasicData 
				lng={props.lng}
				deliveryChange={props.deliveryChange}
			/>
		</div>
	)
}

let DavronFormFirstPage = props => {
	const {handleSubmit, userType, lng} = props
	let isCompany = (userType === 'company' ? true : false)

	const companyChange = () => {
		props.change('userType', 'company')
		props.change('service', 'translation')
		props.change('trackedLetterDelivery', true)
	}
	const individualChange = () => {
		props.change('userType', 'individual')
		props.change('service', 'official')
		props.change('trackedLetterDelivery', false)
	}

	return (
	<div className="row">
		<div className="before-form">
		<form onSubmit={handleSubmit}>
			<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={300}
			>
			
				<UserType 
				 lng={lng}
				 companyChange= {companyChange}
				 individualChange = {individualChange}
				/>

			</CSSTransitionGroup>
			<CSSTransitionGroup
				transitionName="davron"
				transitionEnterTimeout={500}
				transitionLeaveTimeout={300}
			>

				{props.userType!==undefined&&<DavronFormBasicData 
					isCompany={isCompany}
					lng={lng}
					deliveryChange={props.deliveryChange}
					/>}
				{props.userType!==undefined&&<div className="buttons">
				<button type="submit" className="btn btn-orange next">{i18n.t('button.next', {lng})}</button>
				</div>}
			</CSSTransitionGroup>
		</form>
		</div>
	</div>
  )
}

DavronFormFirstPage = connect(
	(state, props) => ({
		userType: selector(state, 'userType')
	})
)(DavronFormFirstPage)

export default reduxForm({
	form: 'davron',
	initialValues: {currency: "EUR", translationLevel: "premium", emailDelivery: true, totalQty: 0, 
		billingCountry: "France", shippingCountry: "France",deadline: "5BusinessDays", interpretorsNumber: 1, 
		audienceNumber: 1, sameAddress: true, trackedLetterDelivery: false},
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	asyncValidate,
	asyncChangeFields: ['currency'],
	validate
})(DavronFormFirstPage)


// WEBPACK FOOTER //
// ./src/DavronFormFirstPage.js